import React from 'react';
import PropTypes from 'prop-types';
import { FooterColumn } from './styled/AdventCalendar';
import HtmlContent from './HtmlContent';

export default class Footer extends React.Component {
  render() {
    const {
      shareContent,
      companyLogoImg,
      text,
    } = this.props;

    let companyLogo = (<FooterColumn />);
    if (companyLogoImg) {
      companyLogo = (
        <div className="footer-col">
          <img src={companyLogoImg} alt="" />
        </div>
      );
    }

    return (
      <div className="adventcalendar__footer">
        <div className="footer-col" dangerouslySetInnerHTML={{ __html: shareContent }} />
        {companyLogo}
        <div className="footer-col">
          <HtmlContent content={text} />
        </div>
      </div>
    );
  }
}

Footer.propTypes = {
  shareContent: PropTypes.string,
  companyLogoImg: PropTypes.string,
  text: PropTypes.string,
};

Footer.defaultProps = {
  shareContent: '',
  companyLogoImg: '',
  text: '',
};
